import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DatePicker, Progress, Tooltip, Tabs, Spin, Switch, Popover } from 'antd';
import cubejs from '@cubejs-client/core';
import { 
  LeftOutlined, 
  RightOutlined,
  SearchOutlined,
  LoadingOutlined,
  AimOutlined, 
  CheckCircleOutlined, 
  ClockCircleOutlined, 
  DollarOutlined,
  BarChartOutlined,
  TeamOutlined,
  CalendarOutlined,
  TrophyOutlined
} from '@ant-design/icons';
import './Incentive.css';
import moment from 'moment';
import {handleTagertMetrics,handleQueryMyCaseCount,handleQueryClientView} from './index'
import { use } from 'react';
import ClientView from './ClientView';
import DayDetailModal from './DayDetailModal';
import { processModalityData } from './index';
import axios from 'axios';
const { TabPane } = Tabs;


function Incentive({ accessLevel, radioValue, modality,teamName, }) {

  // State for current month view
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [allPodData, setAllPodData] = useState([]);
  // State for selected pod
  const [selectedPod, setSelectedPod] = useState('Radiology');
  const [dailyData, setDailyData] = useState({});
  // State for active tab
  const [activeTab, setActiveTab] = useState('statistics');
  const [targetMetrics, setTargetMetrics] = useState([]);
  const [loader, setLoader] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [caseCount, setCaseCount] = useState([]);
  const [caseCountData, setCaseCountData] = useState([]);
  const [podData, setPodData] = useState([]);
  const [othersData, setOthersData] = useState({ total: 0, datewise_date: {} });
  const [clientData, setClientData] = useState([]);
  // const [isrTargetAchieved, setIsrTargetAchieved] = useState(0);
  // Add loading state
  const [loading, setLoading] = useState(true);

  // Add state for view toggle
  const [viewMode, setViewMode] = useState('calendar'); // 'calendar' or 'client'

  // Add state for day detail modal
  const [dayModalVisible, setDayModalVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDayData, setSelectedDayData] = useState(null);

  useEffect(()=>{
    // console.log(accessLevel,'accessLevel')
    setCurrentUser(accessLevel?.name)
  },[accessLevel])


  useEffect(()=>{
    if(accessLevel?.access_scope?.includes('admin')){
      setCurrentUser(teamName)
    }
  },[teamName])

  

  // Generate sample daily data
  const generateDailyData = () => {
    if(selectedPod?.name == 'Others'){
      const data = {};
      const daysInMonth = currentMonth?.daysInMonth();
      const currentInsights = othersData
  
      for (let i = 1; i <= daysInMonth; i++) {
        
        const dayDate = currentMonth.clone().date(i).format('YYYY-MM-DD');
        const isWeekend = currentMonth.clone().date(i).day() === 0 || currentMonth.clone().date(i).day() === 6;
        
        data[dayDate] = currentInsights?.datewise_date?.[dayDate]
      }
      return data
    }
    const data = {};
    const daysInMonth = currentMonth?.daysInMonth();
    const currentInsights = podData?.filter(item => item?.pod_name===selectedPod?.name)

    for (let i = 1; i <= daysInMonth; i++) {

      const dayDate = currentMonth.clone().date(i).format('YYYY-MM-DD');
      const isWeekend = currentMonth.clone().date(i).day() === 0 || currentMonth.clone().date(i).day() === 6;
      
      // Generate lower amounts for weekend
      const basecount= currentInsights?.[0]?.datewise_date?.[dayDate]
      const baseAmount= basecount
      data[dayDate] = currentInsights?.[0]?.datewise_date?.[dayDate]
      data[dayDate] = currentInsights?.[0]?.datewise_date?.[dayDate]
    }
    return data;
  };
  


  useEffect(()=>{
    setDailyData({})
    if(selectedPod && (podData?.length > 0 || othersData?.total > 0)){
      setDailyData(generateDailyData())
      // setDailyData(generateDailyData())

    
    }else{
      if(!selectedPod){
        setSelectedPod({name:'Others',color:'#000000'})
      }
    }
  },[selectedPod,podData])
  
  // Update daily data when month or pod changes
 
  // Function to navigate to previous month
  const prevMonth = () => {
    setCurrentMonth(currentMonth.clone().subtract(1, 'month'));
  };
  
  // Function to navigate to next month
  const nextMonth = () => {
    setCurrentMonth(currentMonth.clone().add(1, 'month'));
  };



  const getPreviousDate = (date) => {
    return moment(date).subtract(1, 'days').format('YYYY-MM-DD');
  };

  const handleCaseCount = async (cubejsApi) => {
    setLoading(true)
    setDailyData({})
    const startDate = currentMonth.startOf('month').format('YYYY-MM-DD')
    const previousDate = getPreviousDate(startDate);
    const last11month = moment(new Date(startDate)).subtract(11, 'months').startOf('month').format('YYYY-MM-DD')
    const endDate = currentMonth.endOf('month').format('YYYY-MM-DD')
    try {
      await cubejsApi
        .load(handleQueryMyCaseCount(currentUser,previousDate,endDate,modality,last11month))
        .then((resultSet) => {
          const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
            return {
              total_case_count: data['Contribution.total_case_count'],
              // pincode: data['Contribution.pincode'],
              client_fk: data['Contribution.client_fk'],
              day_name: data['Contribution.day_name'],
              Date: data['Contribution.Date'],
              modality: data['Contribution.modality']||'Others',
              amount: data['Contribution.incentive_amount'],
              agent_name: data['Contribution.agent_name']
            }
          })
          setCaseCount(modifiedData)
        })
        .catch((error) => {
          console.error("Error fetching API response:", error);
        }); 
    } catch (err) {

    }finally{
      setLoading(false)
    }
  }
  

  useEffect(()=>{
    if(currentUser){
      const cubejsApi = cubejs(
        process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
        {
            apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
        }
    );
        if(cubejsApi){
            handleCaseCount(cubejsApi)
            handleTargetMetrics(cubejsApi)
        }else{
            setTargetMetrics([])
        }
    }
  },[currentUser,modality,currentMonth])


  useEffect(()=>{
    if(currentUser){
      const cubejsApi = cubejs(
        process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
        {
            apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
        }
    );
        // if(cubejsApi&&viewMode==='client'){
            handleClientView(cubejsApi)
        // }else{
        //     setTargetMetrics([])
        // }
    }
  },[currentUser,modality,currentMonth])


  
  const handleClientView = async (cubejsApi) => {
    setLoading(true)
    // setDailyData({})
    const startDate = currentMonth.startOf('month').format('YYYY-MM-DD')
    const previousDate = getPreviousDate(startDate);
    const last11month = moment(new Date(startDate)).subtract(11, 'months').startOf('month').format('YYYY-MM-DD')
    const endDate = currentMonth.endOf('month').format('YYYY-MM-DD')
    try {
      await cubejsApi
        .load(handleQueryClientView(currentUser,previousDate,endDate,modality,last11month))
        .then((resultSet) => {

          console.log(resultSet,'resultSet')
          const pivotedData = resultSet.tablePivot({
            x: ["Contribution.pincode","Contribution.client_name", "Contribution.client_fk", "Contribution.total_case_count"],
            y: ["Contribution.modality","Contribution.final_discount"]
        });

        console.log(pivotedData,'pivotedData')
        const modifiedData = pivotedData.map(data => {
          const processedData = processModalityData(data);

          console.log(processedData,'processedData')
          
          const totalCaseCount = Object.values(processedData.modalities).reduce((total, modality) => {
              return total + Object.values(modality.splits)
                  .filter(value => typeof value === 'number')
                  .reduce((sum, count) => sum + count, 0);
          }, 0);
      
          // Calculate total incentive amount across all modalities and splits
          const totalIncentiveAmount = Object.values(processedData.modalities).reduce((total, modality) => {
              return total + Object.values(modality.splits.incentive_amount)
                  .reduce((sum, amount) => sum + amount, 0);
          }, 0);

          return {
              ...processedData,
              case_count: totalCaseCount,
              incentive_amount: totalIncentiveAmount,
              pincode: data['Contribution.pincode']
          };
      })
      console.log(modifiedData, 'modifiedData')
        // const modifiedData = pivotedData.map(item => {  
        //   return {
        //     client_name: item['Contribution.client_name'],
        //     client_fk: item['Contribution.client_fk'],
        //     pincode: item['Contribution.pincode'],
        //     CT: parseInt(item['CT,Contribution.total_case_count']||0),
        //     MRI: parseInt(item['MRI,Contribution.total_case_count']||0),
        //     XRAY: parseInt(item['XRAY,Contribution.total_case_count']||0),
        //     NM: parseInt(item['NM,Contribution.total_case_count']||0),
        //     total_case_count: (parseInt(item['CT,Contribution.total_case_count']||0) + parseInt(item['MRI,Contribution.total_case_count']||0) + parseInt(item['XRAY,Contribution.total_case_count']||0) + parseInt(item['NM,Contribution.total_case_count']||0) )
        //   }
        // })
        setClientData(modifiedData)
      })
        .catch((error) => {
          console.error("Error fetching API response:", error);
        })
    } catch (err) {

    }finally{
      setLoading(false)
      setLoader(false)
    }
  }
  
  // Function to get data for a specific day
  const getDataForDay = (day) => {
    const dayStr = day.format('YYYY-MM-DD');
    return dailyData?.[dayStr] || { amount: 0, count: 0 };
  };
  
  // Generate calendar days
  const generateCalendarDays = () => {
    const firstDay = currentMonth.clone().startOf('month');
    const startingDayOfWeek = firstDay.day(); // 0 for Sunday, 1 for Monday, etc.
    
    // Generate empty cells for days before the first day of the month
    const emptyCells = Array.from({ length: startingDayOfWeek }).map((_, index) => (
      <div key={`empty-${index}`} className="calendar-day empty"></div>
    ));
    
    // Generate cells for each day in the month
    const daysInMonth = Array.from({ length: currentMonth.daysInMonth() }).map((_, index) => {
      const day = firstDay.clone().add(index, 'days');
      return day;
    });
    
    return { emptyCells, daysInMonth };
  };
  
  const { emptyCells, daysInMonth } = generateCalendarDays();
  const currentInsights = podData?.filter(item => item?.pod_name===selectedPod?.name)
  console.log(currentInsights,'currentInsights')
  const achievedPercentage = Math.round(((currentInsights?.[0]?.CT||0)+(currentInsights?.[0]?.MRI||0) / (currentUser==='All' ? parseInt(selectedPod?.isr_target||0) + parseInt(selectedPod?.fsr_target||0)+parseInt(selectedPod?.target_inactive_to_isr||0)+parseInt(selectedPod?.target_inactive_to_fsr||0) : currentUser===selectedPod?.isr_name ? parseInt(selectedPod?.isr_target||0)+parseInt(selectedPod?.target_inactive_to_isr||0)+parseInt(selectedPod?.fsr_target_for_isr||0) : parseInt(selectedPod?.fsr_target||0)+parseInt(selectedPod?.target_inactive_to_fsr||0)+parseInt(selectedPod?.isr_target_for_fsr||0))) * 100);
  // setIsrTargetAchieved(achievedPercentage)
  // console.log(achievedPercentage,'achievedPercentage')
  const remaining = (currentUser==='All' ? parseInt(selectedPod?.isr_target||0) + parseInt(selectedPod?.fsr_target||0)+parseInt(selectedPod?.target_inactive_to_isr||0)+parseInt(selectedPod?.target_inactive_to_fsr||0) : currentUser===selectedPod?.isr_name ? parseInt(selectedPod?.isr_target||0)+parseInt(selectedPod?.target_inactive_to_isr||0)+parseInt(selectedPod?.fsr_target_for_isr||0) : parseInt(selectedPod?.fsr_target||0)+parseInt(selectedPod?.target_inactive_to_fsr||0)+parseInt(selectedPod?.isr_target_for_fsr||0)) - (((currentInsights?.[0]?.CT||0)+(currentInsights?.[0]?.MRI||0) + (currentInsights?.[0]?.NM||0)) || 0)
  const isrTargetAchieved = (remaining<=0 ? (currentInsights?.[0]?.total_amount/parseInt(selectedPod?.isr_target||0)*100) : 0)
  const remainingPercentage = Math.round((remaining / (currentUser==='All' ? parseInt(selectedPod?.isr_target||0) + parseInt(selectedPod?.fsr_target||0)+parseInt(selectedPod?.target_inactive_to_isr||0)
    +parseInt(selectedPod?.target_inactive_to_fsr||0) : currentUser===selectedPod?.isr_name ? parseInt(selectedPod?.isr_target||0)+parseInt(selectedPod?.target_inactive_to_isr||0)+parseInt(selectedPod?.fsr_target_for_isr||0) : parseInt(selectedPod?.fsr_target||0)+parseInt(selectedPod?.target_inactive_to_fsr||0)+parseInt(selectedPod?.isr_target_for_fsr||0))) * 100)
  const earnedPercentage = Math.round((currentInsights?.[0]?.total_amount / (currentUser==='All' ? parseInt(selectedPod?.isr_target||0) + parseInt(selectedPod?.fsr_target||0)+parseInt(selectedPod?.target_inactive_to_isr||0)
    +parseInt(selectedPod?.target_inactive_to_fsr||0) : currentUser===selectedPod?.isr_name ? parseInt(selectedPod?.isr_target||0)+parseInt(selectedPod?.target_inactive_to_isr||0)+parseInt(selectedPod?.fsr_target_for_isr||0) : parseInt(selectedPod?.fsr_target||0)+parseInt(selectedPod?.target_inactive_to_fsr||0)+parseInt(selectedPod?.isr_target_for_fsr||0))) * 100);




  const handleTargetMetrics = async (cubejsApi) => {
    setLoader(true)
    try {
        // await cubejsApi
        //     .load(handleTagertMetrics)
        //     .then((resultSet) => {
        //         const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
        //             return {
        //                 pod_fk: data['Target.pod_fk'],
        //                 isr_id: data['Target.isr_id'],
        //                 name: data['Target.pod_name'],
        //                 isr_name: data['Target.isr_name'],
        //                 isr_target: data['Target.isr_target'],
        //                 fsr_id: data['Target.fsr_id'],
        //                 fsr_name: data['Target.fsr_name'],
        //                 fsr_target: data['Target.fsr_target'],
        //                 target_inactive_to_isr: data['Target.target_inactive_to_isr'],
        //                 target_inactive_to_fsr: data['Target.target_inactive_to_fsr'],
        //                 isr_target_for_fsr: data['Target.isr_target_for_fsr'],
        //                 fsr_target_for_isr: data['Target.fsr_target_for_isr'],
        //                 pincodes: data['Target.pincodes'],
        //                 client_ids: data['Target.client_ids']
        //             }
        //         })?.sort((a,b)=>a?.pod_fk-b?.pod_fk)
        //         setAllPodData(modifiedData)
        //         if(accessLevel?.access_scope?.includes('admin') && currentUser==='All'){
        //           setTargetMetrics(modifiedData)
        //           setSelectedPod(modifiedData[0])
        //         }else{
        //           // console.log(currentUser,'currentUser')
        //           setTargetMetrics(modifiedData?.filter(item => item?.isr_name===currentUser || item?.fsr_name===currentUser))
        //           setSelectedPod(modifiedData?.filter(item => item?.isr_name===currentUser || item?.fsr_name===currentUser)[0])
        //         }
        //         setLoader(false)
        //     })
        //     .catch((error) => {
        //         console.error("Error fetching API response:", error);
        //     });
        const res = await axios.get(`${process.env.REACT_APP_YAAKE_BACKEND_URL}api/get_pod_target?date=${currentMonth.format('YYYY-MM-DD')}`)
        if(res.status===200){
          const modifiedData = res?.data?.map(data => {
                        return {
                            pod_fk: data['pod_fk'],
                            isr_id: parseInt(data['isr_id']||0),
                            name: data['pod_name'],
                            isr_name: data['isr_name'],
                            isr_target: parseInt(data['current_isr_target']||0),
                            fsr_id: parseInt(data['fsr_id']||0),
                            fsr_name: data['fsr_name'],
                            fsr_target: parseInt(data['current_fsr_target']||0),
                            target_inactive_to_isr: parseInt(data['target_inactive_to_isr']||0),
                            target_inactive_to_fsr: parseInt(data['target_inactive_to_fsr']||0),
                            isr_target_for_fsr: parseInt(data['isr_target_for_fsr']||0),
                            fsr_target_for_isr: parseInt(data['fsr_target_for_isr']||0),
                            pincodes: data['pincodes'],
                            client_ids: data['client_ids']
                        }
                    })?.sort((a,b)=>a?.pod_fk-b?.pod_fk)
                    setAllPodData(modifiedData)
                    if(accessLevel?.access_scope?.includes('admin') && currentUser==='All'){
                      setTargetMetrics(modifiedData)
                      setSelectedPod(modifiedData[0])
                    }else{
                      // console.log(currentUser,'currentUser')
                      setTargetMetrics(modifiedData?.filter(item => item?.isr_name===currentUser || item?.fsr_name===currentUser))
                      setSelectedPod(modifiedData?.filter(item => item?.isr_name===currentUser || item?.fsr_name===currentUser)[0])
                    }
                    // setLoader(false)
        }

    } catch (err) {

    }finally{
      setLoader(false)
    }
  }

  // useEffect(()=>{
  //   const cubejsApi = cubejs(
  //       process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
  //       {
  //           apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
  //       }
  //   );
  //       if(currentUser){
  //          handleTargetMetrics(cubejsApi)
  //       }else{
  //           setTargetMetrics([])
  //       }
  //  },[currentUser])

  
  // Helper function to convert hex color to rgb
  function hexToRgb(hex) {
    // Remove # if present
    hex = hex.replace('#', '');
    
    // Parse the hex values
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    
    return `${r}, ${g}, ${b}`;
  }
  
  // Update the insight cards to match the image style
  const renderInsightCards = () => {
    if (loading) {
      return (
        <div className="insights-cards">
          <div className="insight-card shimmer">
            <div className="shimmer-value"></div>
            <div className="shimmer-label"></div>
          </div>
          <div className="insight-card shimmer">
            <div className="shimmer-value"></div>
            <div className="shimmer-label"></div>
          </div>
          <div className="insight-card shimmer">
            <div className="shimmer-value"></div>
            <div className="shimmer-label"></div>
          </div>
          <div className="insight-card shimmer">
            <div className="shimmer-value"></div>
            <div className="shimmer-label"></div>
          </div>
        </div>
      );
    }
    
    return (
      selectedPod?.name !== 'Others' ? (
      <div className="insights-cards">
        <motion.div 
          className="insight-card"
          style={{ backgroundColor: '#7E57FF' }}
          whileHover={{ y: -5 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="card-icon">
            <AimOutlined />
          </div>
          <div className="card-content">
            <div className="card-title">Target</div>
            <div className="card-value">{currentUser==='All' ? parseInt(selectedPod?.isr_target||0) + parseInt(selectedPod?.fsr_target||0)+parseInt(selectedPod?.target_inactive_to_isr||0)
              +parseInt(selectedPod?.target_inactive_to_fsr||0) : currentUser===selectedPod?.isr_name ? parseInt(selectedPod?.isr_target||0)+parseInt(selectedPod?.target_inactive_to_isr||0)+parseInt(selectedPod?.fsr_target_for_isr||0) : parseInt(selectedPod?.fsr_target||0)+parseInt(selectedPod?.target_inactive_to_fsr||0)+parseInt(selectedPod?.isr_target_for_fsr||0)}</div>
            <div className="progress-bar">
              <div className="progress-track"></div>
              <div 
                className="progress-fill" 
                style={{ width: `${100}%` }}
              ></div>
            </div>
            <div className="card-percentage">{100}%</div>
          </div>
        </motion.div>
        
        <motion.div 
          className="insight-card"
          style={{ backgroundColor: '#3B82F6' }}
          whileHover={{ y: -5 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          <div className="card-icon">
            <CheckCircleOutlined />
          </div>
          <div className="card-content">
            <div className="card-title">Achieved</div>
            <div className="card-value">{(podData?.find(item => item?.pod_name===selectedPod?.name)?.CT||0) + (podData?.find(item => item?.pod_name===selectedPod?.name)?.MRI||0)  + (podData?.find(item => item?.pod_name===selectedPod?.name)?.NM||0)}</div>
            <div className="progress-bar">
              <div className="progress-track"></div>
              <div 
                className="progress-fill" 
                style={{ width: `${(100 - (remainingPercentage || 0))>=100 ? 100 : (100 - (remainingPercentage || 0))}%` }}
              ></div>
            </div>
            <div className="card-percentage">{(100 - (remainingPercentage || 0)) >= 100 ? 100 : (100 - (remainingPercentage || 0))}%</div>
          </div>
        </motion.div>
        
        <motion.div 
          className="insight-card"
          style={{ backgroundColor: '#F59E0B' }}
          whileHover={{ y: -5 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.2 }}
        >
          <div className="card-icon">
            <ClockCircleOutlined />
          </div>
          <div className="card-content">
            <div className="card-title">Remaining</div>
            <div className="card-value">{remaining <= 0 || remaining === undefined ? 0 : remaining.toLocaleString()}</div>
            <div className="progress-bar">
              <div className="progress-track"></div>
              <div 
                className="progress-fill" 
                style={{ width: `${remainingPercentage <= 0 || remainingPercentage === undefined ? 0 : remainingPercentage}%` }}
              ></div>
            </div>
            <div className="card-percentage">{remainingPercentage <= 0 || remainingPercentage === undefined ? 0 : remainingPercentage}%</div>
          </div>
        </motion.div>
        
        <motion.div 
          className="insight-card"
          style={{ backgroundColor: '#10B981' }}
          whileHover={{ y: -5 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.3 }}
        >
          <div className="card-icon">
            <DollarOutlined />
          </div>
          <div className="card-content">
            <div className="card-title">Earned</div>
            <div className="card-value">₹{remaining<=0 ? podData?.find(item => item?.pod_name===selectedPod?.name)?.total_amount?.toLocaleString() : 0}</div>
            {/* <div className="progress-bar">
              <div className="progress-track"></div>
              <div 
                className="progress-fill" 
                style={{ width: `${remaining<=0 ? (podData?.find(item => item?.pod_name===selectedPod?.name)?.total_amount/podData?.find(item => item?.pod_name===selectedPod?.name)?.isr_target*100) : 0}%` }}
              ></div>
            </div>
            <div className="card-percentage">{remaining<=0 ? earnedPercentage : 0}%</div> */}
          </div>
        </motion.div>
      </div>
      ):
    null)

  };

  
  // Process data when both targetMetrics and caseCountData are available
  useEffect(() => {
    setOthersData({})
    setPodData([])
    if ( caseCount?.length > 0) {
      processPodData();
      // processPodData();
    }
  }, [targetMetrics, caseCount]);
  
  // Function to process and match pincodes
  const processPodData = () => {
    // Initialize data structure for each pod
    const processedPodData = targetMetrics?.map(pod => ({
      pod_id: pod?.pod_fk,
      pod_name: pod?.name,
      total: 0,
      datewise_date: {}
    }));
   
    const others = {
      total: 0,
      total_amount: 0,
      datewise_date: {}
    };
    
    // Process each case count entry
    caseCount.forEach(caseData => {
      const caseCount = parseInt(caseData.total_case_count) || 0;
      // const casePincode = caseData.pincode;
      const caseClient = caseData.client_fk;
      const caseDate = caseData.Date.split('T')[0]; // Extract date part
      const caseModality = caseData.modality;
      const caseAmount = parseInt(caseData.amount) || 0;
      // console.log(caseAmount,'caseAmount')
      // Skip if no pincode (or handle as needed)
      if (!caseClient) {
        // Add to others or handle null pincodes as needed
        others.total += caseCount;
        others[caseModality] = (others[caseModality] || 0)   + caseCount;
        others.total_amount += caseAmount;
        // Initialize date if not already present
        if (!others.datewise_date[caseDate]) {
          others.datewise_date[caseDate] = {};
        }
        if (!others.datewise_date[caseDate][caseModality]) {
          others.datewise_date[caseDate][caseModality] = {};
        }
        // Initialize modality count if not already present, then add to it
        others.datewise_date[caseDate][caseModality]={
          'count': (others.datewise_date[caseDate][caseModality]['count'] || 0)+caseCount,
          'amount': (others.datewise_date[caseDate][caseModality]['amount'] || 0)+caseAmount
        }

        others.datewise_date[caseDate]={
          ...others.datewise_date[caseDate],
          'total_case_count': (others.datewise_date[caseDate]['total_case_count'] || 0)+caseCount,
          'total_amount': (others.datewise_date[caseDate]['total_amount'] || 0)+caseAmount,
        }
      
        return;
      }
      
      // Find matching pod
      let matchFound = false;
      
      for (let i = 0; i < targetMetrics?.length; i++) {
        const pod = targetMetrics?.[i];
        const podClients = pod?.client_ids ? pod?.client_ids?.split(',').map(p => p.trim()) : [];
        
        // Check if case pincode is in pod's pincode list
        if (podClients.includes(caseClient)) {
          // Add to pod total
          processedPodData[i].total += caseCount;
          processedPodData[i][caseModality] = (processedPodData[i][caseModality] || 0) + caseCount;
          
          processedPodData[i].total_amount = (processedPodData[i].total_amount || 0) + caseAmount;

          // Add to pod datewise data
          if (!processedPodData[i].datewise_date[caseDate]) {
            processedPodData[i].datewise_date[caseDate] = {};
          }
          if (!processedPodData[i].datewise_date[caseDate][caseModality]) {
            processedPodData[i].datewise_date[caseDate][caseModality] = {};
          }
          processedPodData[i].datewise_date[caseDate][caseModality]={
            ...processedPodData[i].datewise_date[caseDate][caseModality],
            'count': (processedPodData[i].datewise_date[caseDate][caseModality]['count'] || 0)+caseCount,
            'amount': (processedPodData[i].datewise_date[caseDate][caseModality]['amount'] || 0)+caseAmount
          }

          processedPodData[i].datewise_date[caseDate]={
            ...processedPodData[i].datewise_date[caseDate],
            'total_case_count': (processedPodData[i].datewise_date[caseDate]['total_case_count'] || 0)+caseCount,
            'total_amount': (processedPodData[i].datewise_date[caseDate]['total_amount'] || 0)+caseAmount,
          }
      
          matchFound = true;
          break;
        }
      }
      // If no matching pod found, add to others
      if (!matchFound) {
        others.total += caseCount;
        others[caseModality] = (others[caseModality] || 0) + caseCount;
        others.total_amount += caseAmount;
        if (!others.datewise_date[caseDate]) {
          others.datewise_date[caseDate] = {};
        }
        if (!others.datewise_date[caseDate][caseModality]) {
          others.datewise_date[caseDate][caseModality] = 0;
        }
        
        others.datewise_date[caseDate]={
          ...others.datewise_date?.[caseDate],
          'total_case_count': (others.datewise_date?.[caseDate]?.['total_case_count'] || 0)+caseCount,
          'total_amount': (others.datewise_date?.[caseDate]?.['total_amount'] || 0)+caseAmount,
        }

        others.datewise_date[caseDate][caseModality]={
          ...others.datewise_date?.[caseDate]?.[caseModality],
          'count': (others.datewise_date?.[caseDate]?.[caseModality]?.['count'] || 0)+caseCount,
          'amount': (others.datewise_date?.[caseDate]?.[caseModality]?.['amount'] || 0)+caseAmount
        }
        others.name = 'Others'
      }
    });
    // Update state with processed data

    // setPodData(processedPodData);
    console.log(processedPodData,'processedPodData')
    setPodData(processedPodData);
    setOthersData(others);
  };
  
  // Function to get data for calendar display
  const getCalendarData = (date) => {
    const dateStr = date.format('YYYY-MM-DD');
    const selectedPodData = podData.find(pod => pod.pod_name === selectedPod?.name);
    
    if (selectedPodData && selectedPodData.datewise_date[dateStr]) {
      return {
        amount: selectedPodData.datewise_date[dateStr],
        count: 1 // You can adjust this if you have count information
      };
    }
    
    return { amount: 0, count: 0 };
  };
  
 
  const renderPodComparison = () => {
    if (loading) {
      return (
        <div className="pod-comparison-section">
          <h2 className="section-title">Pod Comparison</h2>
          <div className="pod-comparison-chart">
            {[1, 2, 3, 4].map((index) => (
              <div key={index} className="pod-bar-container shimmer">
                <div className="shimmer-label"></div>
                <div className="shimmer-bar"></div>
                <div className="shimmer-value"></div>
                <div className="shimmer-count"></div>
                <div className="shimmer-count"></div>
              </div>
            ))}
          </div>
        </div>
      );
    }
    

    const allCounts = [...podData.map(pod => pod.total || 0), othersData.total || 0];
    const maxCaseCount = Math.max(...allCounts, 1); // Ensure at least 1 to avoid division by zero
    
    // Calculate total cases for summary
    const totalCases = podData.reduce((sum, pod) => sum + (pod.total || 0), 0) + (othersData.total || 0);
    const matchedCases = podData.reduce((sum, pod) => sum + (pod.total || 0), 0);
    const unmatchedCases = othersData.total || 0;
    const crossSection = podData.reduce((sum, pod) => sum + (pod.CT || 0) + (pod.MRI || 0) + (pod.NM || 0), 0) + (othersData.CT || 0) + (othersData.MRI || 0) + (othersData.NM || 0);
    
    return (
      <div className="pod-comparison-section">
        <h3 className="section-title">Pod Performance Comparison</h3>
        
        <div className="pod-comparison-chart">
          {podData?.sort((a,b)=>b.total-a.total)?.map((pod, index) => {
            // Calculate percentage based on case count
            const percentage = Math.min((pod.total || 0) / maxCaseCount * 100, 100);
            
            // Find pod color from targetMetrics
            const podObj = targetMetrics?.find(p => p?.name === pod?.pod_name);
            const podColor = podObj?.color || (index % 2 === 0 ? '#7E57FF' : '#3B82F6');
            // const 

            const currentPod = targetMetrics?.find(p => p?.name === pod?.pod_name);
            const remaining = (currentUser==='All' ? parseInt(currentPod?.isr_target||0) + parseInt(currentPod?.fsr_target||0) + parseInt(currentPod?.target_inactive_to_isr||0) + parseInt(currentPod?.target_inactive_to_fsr||0) : currentUser===currentPod?.isr_name ? parseInt(currentPod?.isr_target||0) + parseInt(currentPod?.target_inactive_to_isr||0) + parseInt(currentPod?.fsr_target_for_isr||0) : parseInt(currentPod?.fsr_target||0) + parseInt(currentPod?.target_inactive_to_fsr||0) + parseInt(currentPod?.isr_target_for_fsr||0)) - (((pod?.CT||0)+(pod?.MRI||0) + (pod?.NM||0)) || 0)
            const isrTargetAchieved = (remaining<=0 ? (pod?.total_amount/parseInt(currentPod?.isr_target||0)*100) : 0)
            return (
              <motion.div 
                key={pod.pod_id || index}
                className={`pod-bar-container ${selectedPod?.name === pod?.pod_name ? 'selected' : ''}`}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
                onClick={() => setSelectedPod(targetMetrics?.find(p => p?.name === pod?.pod_name))}
              >
                <div className="pod-bar-label">
                  <div className="pod-color-indicator" style={{ backgroundColor: podColor }}></div>
                  <span>{pod.pod_name}</span>
                </div>
                
                <div className="pod-bar-wrapper">
                  <motion.div 
                    className="pod-bar"
                    initial={{ width: 0 }}
                    animate={{ width: `${percentage}%` }}
                    transition={{ duration: 0.5, delay: index * 0.05 }}
                    style={{ backgroundColor: podColor }}
                  />
                </div>
                
                <div className="pod-bar-value">${isrTargetAchieved>0 ? <> {(pod.total_amount || 0).toLocaleString()}</> : 0}</div>
                <div className="pod-bar-count">{pod.total || 0} cases</div>
                {/* <div className="pod-bar-count">{pod.CT?.count || 0} cases</div> */}
                <div className="pod-bar-count">{(pod.CT || 0) + (pod.MRI || 0) + (pod.NM || 0)} cases</div>
              </motion.div>
            );
          })}
          
          <motion.div 
            className="pod-bar-container others"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: podData.length * 0.05 }}
          >
            <div className="pod-bar-label">
              <div className="pod-color-indicator" style={{ backgroundColor: '#F59E0B' }}></div>
              <span>Others</span>
            </div>
            
            <div className="pod-bar-wrapper">
              <motion.div 
                className="pod-bar"
                initial={{ width: 0 }}
                animate={{ width: `${Math.min((othersData.total || 0) / maxCaseCount * 100, 100)}%` }}
                transition={{ duration: 0.5, delay: podData.length * 0.05 }}
                style={{ backgroundColor: '#F59E0B' }}
              />
            </div>
            
            <div className="pod-bar-value"></div>
            <div className="pod-bar-count">{othersData.total || 0} cases</div>
            <div className="pod-bar-count">{(othersData.CT || 0) + (othersData.MRI || 0) + (othersData.NM || 0)} cases</div>
          </motion.div>
        </div>
        
        <div className="pod-comparison-summary">
          <div className="summary-item">
            <div className="summary-label">Total Cases</div>
            <div className="summary-value">{totalCases} cases</div>
          </div>
          <div className="summary-item">
            <div className="summary-label">Pod Cases</div>
            <div className="summary-value">{matchedCases} cases</div>
          </div>
          <div className="summary-item">
            <div className="summary-label">Others Cases</div>
            <div className="summary-value">{unmatchedCases} cases</div>
          </div>
          <div className="summary-item">
            <div className="summary-label">Cross Section</div>
            <div className="summary-value">{crossSection} cases</div>
          </div>
          <div className="summary-item">
            <div className="summary-label">Incentive</div>
            <div className="summary-value">₹{podData?.reduce((sum, pod) =>{
              const currentPod = targetMetrics?.find(p => p?.name === pod?.pod_name);
              const remaining = (currentUser==='All' ? parseInt(currentPod?.isr_target||0) + parseInt(currentPod?.fsr_target||0)+parseInt(currentPod?.target_inactive_to_isr||0)+parseInt(currentPod?.target_inactive_to_fsr||0) : currentUser===currentPod?.isr_name ? parseInt(currentPod?.isr_target||0)+parseInt(currentPod?.target_inactive_to_isr||0)+parseInt(currentPod?.fsr_target_for_isr||0) : parseInt(currentPod?.fsr_target||0)+parseInt(currentPod?.target_inactive_to_fsr||0)+parseInt(currentPod?.isr_target_for_fsr||0)) - (((pod?.CT||0)+(pod?.MRI||0) + (pod?.NM||0)) || 0)
              const isrTargetAchieved = (remaining<=0 ? (pod?.total_amount/parseInt(currentPod?.isr_target||0)*100) : 0)
              return sum + (isrTargetAchieved>0 ? parseInt(pod?.total_amount||0) : 0)
            }, 0)}</div>
          </div>
        </div>
      </div>
    );
  };
  
  // Create a loader component
  const Loader = ({ height = '300px', text = 'Loading data...' }) => {
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
    
    return (
      <div className="loader-container" style={{ height }}>
        <Spin indicator={antIcon} />
        <div className="loader-text">{text}</div>
      </div>
    );
  };
  
  // Update renderCalendar to show loader
  const renderCalendar = () => {
    if (loading) {
      return (
        <div className="calendar-section">
          <div className="calendar-header">
            <div className="calendar-title-section">
              <h2 className="current-month">{currentMonth.format('MMMM YYYY')}</h2>
              <div className="day-indicator">Day {moment().diff(moment().startOf('year'), 'days') + 1}</div>
            </div>
          </div>
          <Loader height="400px" text="Loading calendar data..." />
        </div>
      );
    }
    
    return (
      <div className="calendar-container">
        <div className="calendar-header">
          <div className="calendar-title-section">
            <h2 className="current-month">{currentMonth.format('MMMM YYYY')}</h2>
            <div className="day-indicator">Day {moment().diff(moment().startOf('year'), 'days') + 1}</div>
          </div>
          
          <div className="calendar-controls">
            <motion.button 
              className="month-nav-button prev"
              onClick={prevMonth}
              whileHover={{ scale: 1.1, backgroundColor: '#f0f0f0' }}
              whileTap={{ scale: 0.95 }}
            >
              <LeftOutlined />
            </motion.button>
            <motion.button 
              className="month-nav-button next"
              onClick={nextMonth}
              whileHover={{ scale: 1.1, backgroundColor: '#f0f0f0' }}
              whileTap={{ scale: 0.95 }}
            >
              <RightOutlined />
            </motion.button>
          </div>
        </div>

        <div className="Pod-name">
          {/* <div className="Pod-name-label">Pod Name</div> */}
          {/* <div className="Pod-name-value" style={{marginTop:'10px'}}>{selectedPod?.name} ({currentUser})</div>  */}
        </div>
        
        <motion.div 
          className="calendar-grid"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <div className="weekday-header">
            {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map((day, index) => (
              <div key={index} className="weekday-label">{day}</div>
            ))}
          </div>
         {Object.values(dailyData).length>0 && 
          <div className="calendar-days">
            {emptyCells}
            {daysInMonth.map((day, index) => {
              const dayData = getDataForDay(day);
              const isToday = day.isSame(moment(), 'day');
              const isWeekend = day.day() === 0 || day.day() === 6;
              const hasData = dayData.total_case_count > 0;
              // Calculate color intensity based on amount
              const podColor = targetMetrics?.find(p => p?.name === selectedPod?.name)?.color || '#5E5CE6';
              const maxAmount = 5000; // Adjust based on your data range
              const intensity = hasData ? Math.min(dayData.total_amount / maxAmount, 1) : 0;
              
              return (
                <motion.div 
                  key={index} 
                  className={`calendar-day ${isToday ? 'today' : ''}  ${hasData ? 'has-data' : ''}`}
                  whileHover={{ 
                    scale: 1.05, 
                    zIndex: 5,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                  }}
                  transition={{ duration: 0.2 }}
                >
                  <div className={`day-number ${isToday ? 'today-number' : ''}`}>
                    {day.date()}
                  </div>
                  
                  {hasData && (
                    <motion.div 
                      className="day-data"
                      initial={{ opacity: 0, y: 5 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3, delay: 0.1 }}
                      style={{
                        backgroundColor: `rgba(${hexToRgb(podColor)}, ${0.1 + intensity * 0.2})`,
                        borderLeft: `3px solid ${podColor}`
                      }}
                      onClick={() => {
                        setSelectedDate(day.format('YYYY-MM-DD'));
                        setSelectedDayData(dayData);
                        setDayModalVisible(true);
                      }}
                    >
                      <Popover 
                        content={<ModalityBreakdown dayData={dayData} isrTargetAchieved={isrTargetAchieved} />}
                        title="Modality Breakdown"
                        trigger="hover"
                      >
                        <div className="day-data-container">
                          {isrTargetAchieved>0 ? <div className="data-amount">₹{dayData.total_amount.toLocaleString()}</div> : <div className="not-acheived">₹0</div>}
                          <div className="data-count">{dayData.total_case_count} Cases</div>
                        </div>
                      </Popover>
                    </motion.div>
                  )}
                  
                  {isToday && (
                    <motion.div 
                      className="today-indicator"
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      transition={{ 
                        type: "spring",
                        stiffness: 260,
                        damping: 20,
                        delay: 0.5
                      }}
                    />
                  )}
                </motion.div>
              );
            })}
          </div>
}
        </motion.div>
        
        <div className="calendar-summary">
          <div className="summary-item">
            <div className="summary-label">Monthly Total:</div>
            <div className="summary-value">
              {Object.values(dailyData)?.reduce((sum, day) => sum + parseInt(day?.total_case_count||0), 0)}
            </div>
          </div>
          <div className="summary-item">
            <div className="summary-label">Cross Section:</div>
            <div className="summary-value">
              {Object.values(dailyData)?.reduce((sum, day) => sum + parseInt(day?.CT?.count || 0) + parseInt(day?.MRI?.count || 0) + parseInt(day?.NM?.count || 0), 0)}
            </div>
          </div>
          <div className="summary-item">
            <div className="summary-label">Monthly Incentive:</div>
            <div className="summary-value highlight">
            ₹{isrTargetAchieved>0 ? <> {Math.round(Object.values(dailyData)?.reduce((sum, day) => sum + parseInt(day?.total_amount||0), 0))}</> : 0}
            </div>
          </div>  
        </div>
      </div>
    );
  };
  
  // Toggle view handler
  const handleViewToggle = (checked) => {
    setViewMode(checked ? 'client' : 'calendar');
  };
  
  // Toggle button component
  const ViewToggle = () => (
    <div className="view-toggle">
      <span className={`toggle-label ${viewMode === 'calendar' ? 'active' : ''}`}>
        <CalendarOutlined /> Calendar
      </span>
      <Switch 
        checked={viewMode === 'client'}
        onChange={handleViewToggle}
        className="view-switch"
      />
      <span className={`toggle-label ${viewMode === 'client' ? 'active' : ''}`}>
        <TeamOutlined /> Client
      </span>
    </div>
  );
  
  // Use in your calendar section
  const renderCalendarSection = () => {
    return (
      <div className="calendar-section">
        <div className="section-header">
          <h3 className="section-title"> {selectedPod?.name} ({currentUser})</h3>
          <ViewToggle />
        </div>
        
        {viewMode === 'calendar' ? (
          renderCalendar()
        ) : (
       
          <ClientView isrTargetAchieved={isrTargetAchieved} selectedPod={selectedPod} loading={loading} currentUser={currentUser} clientData={clientData} targetMetrics={targetMetrics} currentMonth={currentMonth} setCurrentMonth={setCurrentMonth} modality={modality} />
        )}
      </div>
    );
  };
  
  return (
    <motion.div 
      className="incentive-dashboard"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="dashboard-container">
        <div className="pods-sidebar">
          {/* <div className="sidebar-header">
            <h2 className="sidebar-title">PODS</h2>
            <div className="sidebar-divider"></div>
          </div> */}
          
          {loading ? (
            <div className="loading-indicator">
              <div className="spinner"></div>
              <div>Loading pods...</div>
            </div>
          ) : (
            <div className="pods-list">
              {targetMetrics?.length > 0 ? (
                targetMetrics?.map((pod, index) => {
                  // Generate a consistent color based on pod name
                  const colors = ['#7E57FF', '#3B82F6', '#F59E0B', '#10B981', '#EC4899', '#8B5CF6', '#EF4444', '#06B6D4'];
                  const podColor = colors[index % colors.length];
                  
                  return (
                    <motion.div 
                      key={pod.pod_fk || index}
                      className={`pod-item ${selectedPod?.name == pod?.name ? 'active' : ''}`}
                      onClick={() => setSelectedPod(pod)}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.2, delay: index * 0.02 }}
                      whileHover={{ 
                        scale: 1.02, 
                        boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
                        borderColor: podColor
                      }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <div className="pod-header">
                        <div className="pod-color" style={{ backgroundColor: podColor }}></div>
                        <div className="pod-name">{pod.name}</div>
                      </div>
                      <div className="pod-details">
                      <div className="pod-personnel">
                          <div className="personnel-item">
                            <span className="personnel-label">ISR:</span> 
                            <span className="personnel-value">{pod.isr_name || 'None'}</span>
                          </div>
                          <div className="personnel-item">
                            <span className="personnel-label">FSR:</span> 
                            <span className="personnel-value">{pod.fsr_name || 'None'}</span>
                          </div>
                        </div>
                        <motion.div 
                          className="pod-target"
                          initial={{ width: 0 }}
                          animate={{ width: '100%' }}
                          transition={{ duration: 0.5, delay: index * 0.05 + 0.2 }}
                        >
                          <span className="target-label">Target:</span> 
                          <span className="target-value">{currentUser==='All' ? 
                          Number(parseInt(pod.isr_target || 0) + parseInt(pod.fsr_target || 0) + parseInt(pod.target_inactive_to_isr || 0) + parseInt(pod.target_inactive_to_fsr || 0) || 0).toLocaleString() 
                          : currentUser===pod?.isr_name ? Number(parseInt(pod.isr_target || 0) + parseInt(pod.target_inactive_to_isr || 0) + parseInt(pod.fsr_target_for_isr || 0) || 0).toLocaleString() 
                          : Number(parseInt(pod.fsr_target || 0) + parseInt(pod.target_inactive_to_fsr || 0) + parseInt(pod.isr_target_for_fsr || 0) || 0).toLocaleString()
                         }</span>
                          </motion.div>
                        </div>
                        {selectedPod === pod.name && (
                        <motion.div 
                          className="pod-active-indicator"
                          layoutId="activeIndicator"
                          style={{ backgroundColor: podColor }}
                        />
                      )}
                    </motion.div>
                  );
                })
              ) :  (othersData &&  othersData?.total <= 0) && (
                <div className="no-pods-message">
                  No pods available. Please check your data source.
                </div>
              )}


              {
                (othersData &&  othersData?.total > 0) ? (

                  <motion.div 
                  key={othersData.pod_fk || 50}
                  className={`pod-item ${selectedPod?.name == othersData?.name ? 'active' : ''}`}
                  onClick={() => setSelectedPod(othersData)}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 1 * 0.05 }}
                  whileHover={{ 
                    scale: 1.02, 
                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
                    borderColor: '#F59E0B'
                  }}
                  whileTap={{ scale: 0.98 }}
                >
                  <div className="pod-header">
                    <div className="pod-color" style={{ backgroundColor: '#F59E0B' }}></div>
                    <div className="pod-name">Others</div>
                  </div>
                  <div className="pod-details">
              
                    <motion.div 
                      className="pod-target"
                      initial={{ width: 0 }}
                      animate={{ width: '100%' }}
                      transition={{ duration: 0.5, delay: 1 * 0.05 + 0.2 }}
                    >
                      <span className="target-label">{currentUser}</span> 
                      {/* <span className="target-value">{Number(pod.isr_target + pod.fsr_target || 0).toLocaleString()}</span> */}
                    </motion.div>
                  </div>
                  {selectedPod === othersData.name && (
                    <motion.div 
                      className="pod-active-indicator"
                      layoutId="activeIndicator"
                      style={{ backgroundColor: '#10B981' }}
                    />
                  )}
                </motion.div>
                  
                ) : null
                
              }
            </div>
          )}
          
          <div className="sidebar-footer">
            <div className="sidebar-stats">
              <div className="stat-item">
                <div className="stat-label">Total Pods</div>
                <div className="stat-value">{targetMetrics?.length}</div>
              </div>
              <div className="stat-item">
                <div className="stat-label">Active ISRs</div>
                <div className="stat-value">
                  {targetMetrics?.filter(pod => pod?.isr_name && !pod?.target_inactive_user)?.length}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="main-content">

          
          <div className="metric-cards">
            {renderInsightCards()}
          </div>

          
          <div className="calendar-section">
            {renderCalendarSection()}
          </div>
          
          {renderPodComparison()}
          
          {/* Day Detail Modal */}
          <DayDetailModal
            visible={dayModalVisible}
            onClose={() => setDayModalVisible(false)}
            date={selectedDate}
            podName={selectedPod}
            dayData={selectedDayData}
            modality={modality}
            currentUser={currentUser}
            allPodData={allPodData}
            targetMetrics={targetMetrics}
            isrTargetAchieved={isrTargetAchieved}
          />
        </div>
      </div>
    </motion.div>
  );
}

const ModalityBreakdown = ({ dayData,isrTargetAchieved }) => (
  <div className="modality-breakdown">
    <div className="breakdown-header">
      <span>Modality</span>
      <span>Cases</span>
      <span>Amount</span>
    </div>

          {dayData?.XRAY?.count > 0 && (
            <div key={dayData?.XRAY} className="breakdown-row">
              <span className={`modality-name XRAY`}>
                XRAY
            </span>
            <span className="modality-count">{dayData?.XRAY?.count}</span>
            <span className="modality-amount">
              ₹{isrTargetAchieved>0 ? <> {dayData?.XRAY?.amount?.toLocaleString()}</> : 0}
            </span>
          </div>
          )}
          {dayData?.CT?.count > 0 && (
            <div key={dayData?.CT} className="breakdown-row">
              <span className={`modality-name CT`}>
                CT
            </span>
            <span className="modality-count">{dayData?.CT?.count}</span>
            <span className="modality-amount">
              ₹{isrTargetAchieved>0 ? <> {dayData?.CT?.amount?.toLocaleString()}</> : 0}
            </span>
          </div>
          )}

          {dayData?.MRI?.count > 0 && (
            <div key={dayData?.MRI} className="breakdown-row">
              <span className={`modality-name MRI`}>
                MRI
            </span>
            <span className="modality-count">{dayData?.MRI?.count}</span>
            <span className="modality-amount">
              ₹{isrTargetAchieved>0 ? <> {dayData?.MRI?.amount?.toLocaleString()}</> : 0}
            </span>
          </div>
          )}
          {dayData?.NM?.count > 0 && (
            <div key={dayData?.NM} className="breakdown-row">
              <span className={`modality-name NM`}>
                NM
            </span>
            <span className="modality-count">{dayData?.NM?.count}</span>
            <span className="modality-amount">
              ₹{isrTargetAchieved>0 ? <> {dayData?.NM?.amount?.toLocaleString()}</> : 0}
            </span>
          </div>
          )}

      
    
    <div className="breakdown-total">
      <span>Total</span>
      <span>{dayData?.total_case_count}</span>
      <span>₹{isrTargetAchieved>0 ? <> {dayData?.total_amount?.toLocaleString()}</> : 0}</span>
    </div>
  </div>
);

export default Incentive;
